import { css } from "@emotion/react";
import { getColor, getFont, matchProps } from "@mrocket/styles";
import styled from "@emotion/styled";
import { TextProps } from "./Text";

const match = matchProps<TextProps>()

const keysOfProps = [
  'appearance',
  'size',
  'font',
  'align'
]

export const TextRoot = styled('div', {
  shouldForwardProp: props => !keysOfProps.includes(props)
})<TextProps>`
  
  font-family: ${props => getFont(props.font)};
  -webkit-tap-highlight-color: transparent;
  line-height: 1.55;
  text-decoration: ${props => props.decoration || "none"};
  font-weight: ${props => props.weight};
  color: ${props => getColor(props.color) || "inherit"};
  text-align: ${props => props.align};
  ${match('size', 1, css`
    font-size: var(--sizeBase7);
    //letter-spacing: 0.02rem;
  `)};
  ${({size}) => (!size || size === 2) && css`
    font-size: calc(var(--sizeBase6));
  `};
  ${match('size', 3, css`
    font-size: calc(var(--sizeBase6) - 2px);
  `)};
  ${match('size', 4, css`
    font-size: calc(var(--sizeBase6) - 3px);
  `)};


`